module.exports = __webpack_public_path__ + "img/like_ribbon_web.1198b64b.svg";